'use strict';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
const FirstSection = document.querySelector(".first_section");
const BurgerMenuButton = document.querySelector(".burger_menu__button");
const BurgerMenu = document.querySelector(".burger_menu");
const Body = document.querySelector("body");
const Icon = document.querySelector(".icon");
const Links = document.querySelectorAll("a");
const U = document.querySelector(".special_character")

const TitleUserJourney = document.querySelector(".user_journey__title")
const TextUserJourney = document.querySelector(".user_journey__text")
const Previous = document.querySelector(".previous");
const Next = document.querySelector(".next");
const NewStory = document.querySelector(".new_story")

const Images = document.querySelectorAll("img");
const Mesures = document.querySelectorAll(".mesure");

const DarkModeButton = document.querySelector(".darkmode_button");
let Buildings = document.querySelectorAll(".cls-1");
let Message = document.querySelectorAll(".show")

let Sora = localStorage.getItem("Light")

if (Sora == "prevail") {
    darkmode()
}

Buildings[0].addEventListener("mouseover", () => {
    Message[0].classList.add("message");
    Message[0].innerHTML = "Bâtiment A"
})
Buildings[1].addEventListener("mouseover", () => {
    Message[0].classList.add("message");
    Message[0].innerHTML = "Bâtiment B et C"
})
Buildings[2].addEventListener("mouseover", () => {
    Message[0].classList.add("message");
    Message[0].innerHTML = "Les blocs bizarres sur le chemin"
})
Buildings[3].addEventListener("mouseover", () => {
    Message[1].classList.add("message");
    Message[1].innerHTML = "Bâtiment A"
})
Buildings[4].addEventListener("mouseover", () => {
    Message[1].classList.add("message");
    Message[1].innerHTML = "Bâtiment B et C"
})
Buildings[5].addEventListener("mouseover", () => {
    Message[1].classList.add("message");
    Message[1].innerHTML = "Les blocs bizarres sur le chemin"
})

DarkModeButton.addEventListener("click", darkmode)

function darkmode() {

    if (document.querySelector("main").classList.contains("lightmode") == false) {
        document.documentElement.style.setProperty('--background-color','#FFF6ED')
        document.documentElement.style.setProperty('--text-color', '#660000');
        document.documentElement.style.setProperty('--footer-header-background-color', '#660000');
        document.documentElement.style.setProperty('--dark-color', '#FFF6ED');
        document.documentElement.style.setProperty('--important', '#4E4FEB');
        localStorage.setItem("Light", "prevail");
        for (let i = 0; i < Links.length; i++) {
            Links[i].classList.toggle("lightmode");
        }
        U.classList.toggle("lightmode")
        document.querySelector(".next").classList.toggle("lightmode");
        document.querySelector(".previous").classList.toggle("lightmode");
        document.querySelector(".new_story").classList.toggle("lightmode");
        document.querySelector("main").classList.toggle("lightmode");
        document.querySelector(".burger_menu__container").classList.toggle("lightmode");
    } else {
        document.documentElement.style.setProperty('--background-color','radial-gradient(circle, #005AB3 0%, #012549 75%)')
        document.documentElement.style.setProperty('--text-color', '#f5f5f5');
        document.documentElement.style.setProperty('--footer-header-background-color', '#dfdfdf');
        document.documentElement.style.setProperty('--dark-color', '#000000');
        document.documentElement.style.setProperty('--important', '#ffd0ac');
        for (let i = 0; i < Links.length; i++) {
            Links[i].classList.toggle("lightmode");
        }
        U.classList.toggle("lightmode")
        document.querySelector(".next").classList.toggle("lightmode");
        document.querySelector(".previous").classList.toggle("lightmode");
        document.querySelector(".new_story").classList.toggle("lightmode");
        document.querySelector("main").classList.toggle("lightmode")
        document.querySelector(".burger_menu__container").classList.toggle("lightmode");
        localStorage.setItem("Light", "vanish");

    }
    
    
}

Next.addEventListener("click", next);
Previous.addEventListener("click", back);
NewStory.addEventListener("click", NouveauScenar);

BurgerMenuButton.addEventListener("click", ()=> {
    BurgerMenu.classList.toggle("display");
    Body.classList.toggle("fixed");
    Icon.classList.toggle("flip");
})
window.addEventListener("scroll", () => {
    if (window.scrollY >= FirstSection.offsetTop) {
        BurgerMenuButton.classList.add("visible");
    } else {
        BurgerMenuButton.classList.remove("visible");
    }   
})

function next() {
    if (TitleUserJourney.innerHTML == "Scénario 1") {
        if (TextUserJourney.innerHTML == "Paul trouve qu'il fait beau, il souhaite jouer avec ses amis au ping pong à l'extérieur") {
            TextUserJourney.innerHTML = "Il se rend sur la cour";
        }
        else if (TextUserJourney.innerHTML == "Il se rend sur la cour") {
            TextUserJourney.innerHTML = "Il voit qu'il reste des tables libres et s'intalle";
        }
        else if (TextUserJourney.innerHTML == "Il voit qu'il reste des tables libres et s'intalle") {
            TextUserJourney.innerHTML = "Il installe le filet portable et se prépare à jouer";
        }
        else if (TextUserJourney.innerHTML == "Il installe le filet portable et se prépare à jouer") {
            TextUserJourney.innerHTML = "Il commence  à jouer avec son ami, mais il se rend compte que les fentes des tables de camping l'empêche de bien jouer";
        }
        else if (TextUserJourney.innerHTML == "Il commence  à jouer avec son ami, mais il se rend compte que les fentes des tables de camping l'empêche de bien jouer") {
            TextUserJourney.innerHTML = "Il décide donc de ranger son filet et annule son plan de jeu...";
            document.querySelector(".smiley").innerHTML = "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm0 14c-2.33 0-4.14 1.64-5.09 2.8l.47.58c1.29-.82 2.73-1.31 4.62-1.31s3.34.49 4.62 1.31l.47-.58C16.14 15.64 14.33 14 12 14ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
    }

    else if (TitleUserJourney.innerHTML == "Scénario 2") {
        if (TextUserJourney.innerHTML == "Grégoire souhaite manger avec ses amis à l'extérieur malgré qu'il soit en chaise roulante") {
            TextUserJourney.innerHTML = "Il se rend sur la cour";
        }
        else if (TextUserJourney.innerHTML == "Il se rend sur la cour") {
            TextUserJourney.innerHTML = "Il reste des places disponibles, il s'installe sur une table avec ses amis";
        }
        else if (TextUserJourney.innerHTML == "Il reste des places disponibles, il s'installe sur une table avec ses amis") {
            TextUserJourney.innerHTML = "Les bancs étant attachés à la table de camping, il ne peut se mettre qu'aux extrémités de la table";
        }
        else if (TextUserJourney.innerHTML == "Les bancs étant attachés à la table de camping, il ne peut se mettre qu'aux extrémités de la table") {
            TextUserJourney.innerHTML = "Il se rend vite compte qu'étant à l'extrémité de la table, le peu de surface qu'il lui reste ne le permet pas de manger tranquillement";
        }
        else if (TextUserJourney.innerHTML == "Il se rend vite compte qu'étant à l'extrémité de la table, le peu de surface qu'il lui reste ne le permet pas de manger tranquillement") {
            TextUserJourney.innerHTML = "Il met sa boîte sur ses genoux ce qui diminue son expérience utilisateurs par rapport à ses amis...";
            document.querySelector(".smiley").innerHTML = "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm0 14c-2.33 0-4.14 1.64-5.09 2.8l.47.58c1.29-.82 2.73-1.31 4.62-1.31s3.34.49 4.62 1.31l.47-.58C16.14 15.64 14.33 14 12 14ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
    }    
    else if (TitleUserJourney.innerHTML == "Scénario 3") {
        if (TextUserJourney.innerHTML == "Pierre souhaite se rendre rapidement à son cours au bloc A alors qu'il se trouve dans le bâtiment B et qu'il pleut") {
            TextUserJourney.innerHTML = "Il se rend sur la cour";
        }
        else if (TextUserJourney.innerHTML == "Il se rend sur la cour") {
            TextUserJourney.innerHTML = "Il remarque vite que la pelouse est glissante";
        }
        else if (TextUserJourney.innerHTML == "Il remarque vite que la pelouse est glissante") {
            TextUserJourney.innerHTML = "Il glisse et tombe à terre";
            document.querySelector(".smiley").innerHTML = "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm0 14c-2.33 0-4.14 1.64-5.09 2.8l.47.58c1.29-.82 2.73-1.31 4.62-1.31s3.34.49 4.62 1.31l.47-.58C16.14 15.64 14.33 14 12 14ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
        else if (TextUserJourney.innerHTML == "Il glisse et tombe à terre") {
            TextUserJourney.innerHTML = "Il réalise que des chemins en béton ont été réalisés pour se rendre à ses cours sans qu'il doivent marcher sur le gazon artificiel";
            document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
        else if (TextUserJourney.innerHTML == "Il réalise que des chemins en béton ont été réalisés pour se rendre à ses cours sans qu'il doivent marcher sur le gazon artificiel") {
            TextUserJourney.innerHTML = "Il emprunte les chemins en béton et rejoint le bâtiment A";
        }
    }
}
function back() {
    if (TitleUserJourney.innerHTML == "Scénario 1") {
        if (TextUserJourney.innerHTML == "Il décide donc de ranger son filet et annule son plan de jeu...") {
            TextUserJourney.innerHTML = "Il commence  à jouer avec son ami, mais il se rend compte que les fentes des tables de camping l'empêche de bien jouer";
            document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
        else if (TextUserJourney.innerHTML == "Il commence  à jouer avec son ami, mais il se rend compte que les fentes des tables de camping l'empêche de bien jouer") {
            TextUserJourney.innerHTML = "Il installe le filet portable et se prépare à jouer";
        }
        else if (TextUserJourney.innerHTML == "Il installe le filet portable et se prépare à jouer") {
            TextUserJourney.innerHTML = "Il voit qu'il reste des tables libres et s'intalle";
        }
        else if (TextUserJourney.innerHTML == "Il voit qu'il reste des tables libres et s'intalle") {
            TextUserJourney.innerHTML = "Il se rend sur la cour";
        }
        else if (TextUserJourney.innerHTML == "Il se rend sur la cour") {
            TextUserJourney.innerHTML = "Paul trouve qu'il fait beau, il souhaite jouer avec ses amis au ping pong à l'extérieur";
        }
    }
    else if (TitleUserJourney.innerHTML == "Scénario 2") {
        if (TextUserJourney.innerHTML == "Il met sa boîte sur ses genoux ce qui diminue son expérience utilisateurs par rapport à ses amis...") {
            TextUserJourney.innerHTML = "Il se rend vite compte qu'étant à l'extrémité de la table, le peu de surface qu'il lui reste ne le permet pas de manger tranquillement";
            document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
        else if (TextUserJourney.innerHTML == "Il se rend vite compte qu'étant à l'extrémité de la table, le peu de surface qu'il lui reste ne le permet pas de manger tranquillement") {
            TextUserJourney.innerHTML = "Les bancs étant attachés à la table de camping, il ne peut se mettre qu'aux extrémités de la table";
        }
        else if (TextUserJourney.innerHTML == "Les bancs étant attachés à la table de camping, il ne peut se mettre qu'aux extrémités de la table") {
            TextUserJourney.innerHTML = "Il reste des places disponibles, il s'installe sur une table avec ses amis";
        }
        else if (TextUserJourney.innerHTML == "Il reste des places disponibles, il s'installe sur une table avec ses amis") {
            TextUserJourney.innerHTML = "Il se rend sur la cour";
        }
        else if (TextUserJourney.innerHTML == "Il se rend sur la cour") {
            TextUserJourney.innerHTML = "Grégoire souhaite manger avec ses amis à l'extérieur malgré qu'il soit en chaise roulante";
        }
    }
    else if (TitleUserJourney.innerHTML == "Scénario 3") {
        if (TextUserJourney.innerHTML == "Il emprunte les chemins en béton et rejoint le bâtiment A") {
            TextUserJourney.innerHTML = "Il réalise que des chemins en béton ont été réalisés pour se rendre à ses cours sans qu'il doivent marcher sur le gazon artificiel";
        }
        else if (TextUserJourney.innerHTML == "Il réalise que des chemins en béton ont été réalisés pour se rendre à ses cours sans qu'il doivent marcher sur le gazon artificiel") {
            TextUserJourney.innerHTML = "Il glisse et tombe à terre";
            document.querySelector(".smiley").innerHTML = "<svg data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm0 14c-2.33 0-4.14 1.64-5.09 2.8l.47.58c1.29-.82 2.73-1.31 4.62-1.31s3.34.49 4.62 1.31l.47-.58C16.14 15.64 14.33 14 12 14ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
        else if (TextUserJourney.innerHTML == "Il glisse et tombe à terre") {
            TextUserJourney.innerHTML = "Il remarque vite que la pelouse est glissante";
            document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

        }
        else if (TextUserJourney.innerHTML == "Il remarque vite que la pelouse est glissante") {
            TextUserJourney.innerHTML = "Il se rend sur la cour";
        }
        else if (TextUserJourney.innerHTML == "Il se rend sur la cour") {
            TextUserJourney.innerHTML = "Pierre souhaite se rendre rapidement à son cours au bloc A alors qu'il se trouve dans le bâtiment B et qu'il pleut";
        }
    }
}

function NouveauScenar() {
    if (TitleUserJourney.innerHTML == "Scénario 1") { 
        TitleUserJourney.innerHTML = "Scénario 2"
        TextUserJourney.innerHTML = "Grégoire souhaite manger avec ses amis à l'extérieur malgré qu'il soit en chaise roulante"
        document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

    }
    else if (TitleUserJourney.innerHTML == "Scénario 2") { 
        TitleUserJourney.innerHTML = "Scénario 3"
        TextUserJourney.innerHTML = "Pierre souhaite se rendre rapidement à son cours au bloc A alors qu'il se trouve dans le bâtiment B et qu'il pleut";
        document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

    } else if (TitleUserJourney.innerHTML == "Scénario 3") { 
        TitleUserJourney.innerHTML = "Scénario 1"
        TextUserJourney.innerHTML = "Paul trouve qu'il fait beau, il souhaite jouer avec ses amis au ping pong à l'extérieur"
        document.querySelector(".smiley").innerHTML = "<svg class='smiley' data-name='Layer 1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M12 2c5.51 0 10 4.49 10 10s-4.49 10-10 10S2 17.51 2 12 6.49 2 12 2Zm0-2C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0Zm5.51 13.94C16 15.13 14.34 15.87 12 15.87s-4-.74-5.51-1.93l-.49.49C7.13 16.15 9.2 18 12 18s4.87-1.85 6-3.57l-.49-.49ZM8.5 8C7.67 8 7 8.67 7 9.5S7.67 11 8.5 11s1.5-.67 1.5-1.5S9.33 8 8.5 8Zm7 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5S16.33 8 15.5 8Z'/></svg>"

    }
}
Mesures[0].innerHTML = Images[0].width + " px";
Mesures[1].innerHTML = Images[1].width + " px";
Mesures[2].innerHTML = Images[10].width + " px";
Mesures[3].innerHTML = Images[11].width + " px";
Mesures[4].innerHTML = Images[12].width + " px";
Mesures[5].innerHTML = Images[13].width + " px";

window.addEventListener("resize", () => {
    Mesures[0].innerHTML = Images[0].width + " px";
    Mesures[1].innerHTML = Images[1].width + " px";
    Mesures[2].innerHTML = Images[10].width + " px";
    Mesures[3].innerHTML = Images[11].width + " px";
    Mesures[4].innerHTML = Images[12].width + " px";
    Mesures[5].innerHTML = Images[13].width + " px";

})
let SecondSection = document.querySelector(".second_section");
let Paragraph = document.querySelectorAll(".first_paragraph");
let TextContainer = document.querySelectorAll(".texte_container");
let cdiv = function cdiv(x) {
    /* https://www.w3schools.com/howto/howto_js_media_queries.asp */
    if (x.matches  == true && TextContainer[1].contains(Paragraph[1]) == false) {
        TextContainer[1].prepend(Paragraph[1]);
    }
  };

  let ediv = function ediv(x1) {
    if (x1.matches && TextContainer[1].contains(Paragraph[1]) == true) {
      SecondSection.insertBefore(Paragraph[1], SecondSection.children[1])
    }
  };

  let x = window.matchMedia("(min-width: 1000px)");

  cdiv(x);

  x.addListener(cdiv);

  let x2 = window.matchMedia("(max-width: 999px)");

  ediv(x2);
  x2.addListener(ediv);

  const FirstLink = document.getElementById("first_link");
  const SecondLink = document.getElementById("second_link");
  const ThirdLink = document.getElementById("third_link");
  const FourthLink = document.getElementById("fourth_link");
  const FifthLink = document.getElementById("fifth_link");
  FirstLink.addEventListener("click", (e) => {
    e.preventDefault;
    gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".first_section").offsetTop - 50)})
  })
  SecondLink.addEventListener("click", (e) => {
    e.preventDefault;
    gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".second_section").offsetTop - 50)})
  })
  ThirdLink.addEventListener("click", (e) => {
    e.preventDefault;
    gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".third_section").offsetTop - 50)})
  })
  FourthLink.addEventListener("click", (e) => {
    e.preventDefault;
    gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".fourth_section").offsetTop - 50)})
  })
  FifthLink.addEventListener("click", (e) => {
    e.preventDefault;
    gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".fifth_section").offsetTop - 50)})
  })

  const FirstBurgerLink = document.getElementById("first_link_burger");
  const SecondBurgerLink = document.getElementById("second_link_burger");
  const ThirdBurgerLink = document.getElementById("third_link_burger");
  const FourthBurgerLink = document.getElementById("fourth_link_burger");
  const FifthBurgerLink = document.getElementById("fifth_link_burger");

  FirstBurgerLink.addEventListener("click", (e) => {
    e.preventDefault;
    BurgerMenu.classList.toggle("display");
    Body.classList.toggle("fixed");
    Icon.classList.toggle("flip");
    gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".first_section").offsetTop - 50)})
    
    })

    SecondBurgerLink.addEventListener("click", (e) => {
        e.preventDefault;
        BurgerMenu.classList.toggle("display");
        Body.classList.toggle("fixed");
        Icon.classList.toggle("flip");
        gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".second_section").offsetTop - 50)})
        
        })

    ThirdBurgerLink.addEventListener("click", (e) => {
        e.preventDefault;
        BurgerMenu.classList.toggle("display");
        Body.classList.toggle("fixed");
        Icon.classList.toggle("flip");
        gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".third_section").offsetTop - 50)})
        
        })
    FourthBurgerLink.addEventListener("click", (e) => {
        e.preventDefault;
        BurgerMenu.classList.toggle("display");
        Body.classList.toggle("fixed");
        Icon.classList.toggle("flip");
        gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".fourth_section").offsetTop - 50)})
            
        })
    FifthBurgerLink.addEventListener("click", (e) => {
        e.preventDefault;
        BurgerMenu.classList.toggle("display");
        Body.classList.toggle("fixed");
        Icon.classList.toggle("flip");
        gsap.to(window, {duration: 0.5, scrollTo: (document.querySelector(".fifth_section").offsetTop - 50)})
        
        })

        let SwitchImage = document.querySelector(".switch_image")
        SwitchImage.addEventListener("click", () => {
            if (Images[5].classList.contains("back") == true) {
                Images[5].classList.add("switch_back");
                Images[6].classList.add("switch_forward");
                setTimeout(classOn, 1000);

                function classOn() {
                    Images[5].classList.remove("switch_back");
                    Images[6].classList.remove("switch_forward");
                    Images[5].classList.toggle("back");
                    Images[6].classList.toggle("back");
                }
            } else if (Images[6].classList.contains("back") == true) {
                Images[6].classList.add("switch_back");
                Images[5].classList.add("switch_forward");
                setTimeout(classOn, 1000);

                function classOn() {
                    Images[6].classList.remove("switch_back");
                    Images[5].classList.remove("switch_forward");
                    Images[5].classList.toggle("back");
                    Images[6].classList.toggle("back");
                }
            }
        })